import React, { useContext } from "react"

import Paper from "@material-ui/core/Paper"
import Container from "@material-ui/core/Container"
import Grid from "@material-ui/core/Grid"
import { makeStyles } from "@material-ui/core/styles"
import Typography from "@material-ui/core/Typography";

import useTickets from "../../hooks/useTickets"

import { AuthContext } from "../../context/Auth/AuthContext";

import { i18n } from "../../translate/i18n";


const Dashboard = () => {
  const iframeStyle = {
    width: "100%",
    height: "100vh", // 100% da altura da janela do navegador
    border: "none", // Para remover a borda do iframe
  };

  return (
    <iframe
      src="https://dashboard.hrdsup.com.br/public/dashboard/a57750b5-4d65-4f28-bf02-c22353c86265"
      style={iframeStyle}
      allowTransparency="true"
    ></iframe>
  );
};

export default Dashboard
